import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { Providers } from './providers';
import { CssBaseline } from '@mui/material';
import { Routes } from './pages';

function App() {
  return (
    <>
      <CssBaseline />
      <Providers>
        <Routes />
      </Providers>
    </>
  );
}

export default App;
